import { render } from "./TableBodyRow.vue?vue&type=template&id=d2ab5eb0&ts=true"
import script from "./TableBodyRow.vue?vue&type=script&lang=ts"
export * from "./TableBodyRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__